import { render, staticRenderFns } from "./ShippingLabel.vue?vue&type=template&id=6128087f&scoped=true"
import script from "./ShippingLabel.vue?vue&type=script&lang=js"
export * from "./ShippingLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6128087f",
  null
  
)

export default component.exports